import httpClient from "./httpClient";

export function listUsers() {
  return httpClient.get("/users").then((res) => res.data.data);
}

export function listSuperAdmins() {
  return httpClient.get("/users/super-admins").then((res) => res.data.data);
}

export function createUser(payload) {
  return httpClient.post("/users", payload).then((res) => res.data.data);
}

export function updateUser(id, payload) {
  return httpClient.put(`/users/${id}`, payload).then((res) => res.data.data);
}

export function deleteUser(id) {
  return httpClient.delete(`/users/${id}`).then((res) => res.data);
}
